import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/mainDashboard')));

const ExportTicket = Loadable(lazy(() => import('views/pages/administrator/export/ExportTickets')));
const ExportProduction = Loadable(lazy(() => import('views/pages/administrator/export/ExportProduction')));

// ==============================|| MAIN ROUTING ||============================== //

const ManagerRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <DashboardDefault />
                }
            ]
        },
        {
            path: 'export',
            children: [
                {
                    path: 'tickets',
                    element: <ExportTicket />
                },
                {
                    path: 'production',
                    element: <ExportProduction />
                }
            ]
        },
        {
            path: '*',
            element: <DashboardDefault />
        }
    ]
};

export default ManagerRoutes;
